import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { SwitchButtonType, SingleSwitchButton } from './SingleSwitchButton';

export type SwitchButtonProps = PropsWithChildren<{
  buttons: SwitchButtonType[];
  selectedButton: string;
  onChange: (value: SwitchButtonType['value']) => void;
}>;

const SwitchButtonBase = styled.div`
  box-sizing: border-box;
  text-align: center;
  width: fit-content;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${theme.borderRadius.default};
  background-color: ${theme.colors.neutrals.solidGrays[7]};
  color: ${theme.colors.primary.graysGray};
`;

export const SwitchButton: React.FC<SwitchButtonProps> = ({
  buttons,
  selectedButton,
  onChange,
}) => {
  const handleClick = (value: string) => {
    onChange(value);
  };

  return (
    <SwitchButtonBase>
      {buttons.map(({ label, value, icon }) => (
        <SingleSwitchButton
          key={value}
          label={label}
          value={value}
          handleClick={handleClick}
          isSelected={selectedButton === label}
          icon={icon}
        />
      ))}
    </SwitchButtonBase>
  );
};
